<mat-drawer-container class="example-container" [hasBackdrop]="true">
  <mat-drawer-content>
    <div id="main-wrapper">
      @if (showChrome) {
        <app-side-nav [isNavOpen]="isNavOpen" [isMobileNav]="isMobileNav" [isMobileNavOpen]="isMobileNavOpen"></app-side-nav>
      }
      <div class="page-wrapper" [class]="showChrome ? (isNavOpen ? (isMobileNav ? 'mobile-nav' : 'nav-open') : 'nav-close') : ''">
        @if (showChrome) {
          <app-header [isNavOpen]="isNavOpen" [isMobileNav]="isMobileNav" [isMobileNavOpen]="isMobileNavOpen"></app-header>
        }
        <div class="page-wrapper-inner">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer #drawer [mode]="'over'" position="end">
    <div class="activity">
      @if (nav?.activity=='change-password') {
        <change-password [data]="nav"></change-password>
      }
      @if (nav?.activity=='cancel-journey') {
        <cancel-journey [data]="nav"></cancel-journey>
      }
      @if (nav?.activity=='grade-details') {
        <grade-details [data]="nav"></grade-details>
      }
      @if (nav?.activity=='trip') {
        <trip-activity [data]="nav"></trip-activity>
      }
      @if (nav?.activity=='expense') {
        <expense-activity [data]="nav"></expense-activity>
      }
      @if (nav?.activity=='notifications') {
        <notifications [data]="nav"></notifications>
      }
      @if (nav?.activity=='help-and-support') {
        <help-and-support [data]="nav"></help-and-support>
      }
      @if (nav?.activity=='request-a-call') {
        <request-a-call [data]="nav"></request-a-call>
      }
      @if (nav?.activity=='contact-support') {
        <contact-support [data]="nav"></contact-support>
      }
      @if (nav?.activity=='table-filter') {
        <table-filter [data]="nav"></table-filter>
      }
      @if (nav?.activity=='new-travel-doc') {
        <new-travel-doc [data]="nav"></new-travel-doc>
      }
    </div>
  </mat-drawer>
</mat-drawer-container>
